import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {ref} from "vue";
import {requiredRule} from "~/core-ui/ts/CoreUiHelpersMixin";


const __default__ = {
    name: "OperatorApplicationSendToSupportDialog"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    userdata: {},
    selectedMessages: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: ["update:visible"],
  setup(__props: any) {

let props = __props;

let isVisible = _useModel<boolean>(__props, "visible");
function close() {
    isVisible.value = false;
}
let text = ref(props.selectedMessages);

async function emitApply() {
    let p: OperatorApplicationApi.OperatorSendToSupportOpenApiModel = {
        username: props.userdata.username,
        text: text.value
    };
    let result = await (new OperatorApiRequest({
        url: "/message/sendToSupport",
        p
    })).save();
    if (result.isSuccess) {
        close();
    }
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_unref(isVisible))
    ? (_openBlock(), _createBlock(MyDialog, {
        key: 0,
        title: "Отправка вопроса в ТП",
        onApply: emitApply,
        form: {labelPosition: 'top', model: {text: _unref(text)}},
        visible: _unref(isVisible),
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            rules: _unref(requiredRule),
            label: "Введите текст вопроса. Внимание, он будет виден клиенту!",
            prop: "text"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                autosize: {minRows:5, maxRows: 20},
                modelValue: _unref(text),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(text) ? (text).value = $event : text = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["rules"])
        ]),
        _: 1
      }, 8, ["form", "visible"]))
    : _createCommentVNode("", true)
}
}

})